<div class="blog-summary">
  <div class="blog-summary__accordion" *ngIf="summaryData.length > 0">
    <ng-container *ngFor="let summary of summaryData; let i = index">
      <app-accordion
        [name]="'summaryPanel' + i"
        [maxHeight]="i === activeIndex ? maxHeight : '0px'"
        (onClick)="toggleAccordian(i)"
        [dataSource]="summary"
        [isMenuOpen]="i === menuOpenIndex"
        (closeAllMenu)="closeAllMenu(i)"
        (openMenu)="openMenu(i)"
        (onDelete)="onDelete(i)"
        (onEdit)="onEdit(i)"
      ></app-accordion>
    </ng-container>
  </div>
  <div class="blog-summary__form">
    <form [formGroup]="summaryForm">
      <div class="input-field">
        <label>Summary Title <span>*</span></label>
        <input type="text" placeholder="Enter Title" formControlName="title" />
        <span
          *ngIf="summaryForm.get('title')?.errors?.['required']&&(summaryForm.get('title')?.dirty||summaryForm.get('title')?.touched)"
        >
          Title is required
        </span>
      </div>
      <app-custom-editor
        label="Summary Content"
        controlName="content"
        [form]="summaryForm"
      ></app-custom-editor>
      <div
        class="is-error"
        *ngIf="summaryForm.get('content')?.errors?.['required']&&(summaryForm.get('content')?.dirty||summaryForm.get('content')?.touched)"
      >
        Content is required
      </div>
      <div class="blog-summary__footer flex justify-end">
        <app-button
          customClass="outline"
          label="Clear"
          type="button"
          (action)="clearForm()"
        >
        </app-button>
        <app-button
          type="submit"
          [label]="editIndex>-1?'Update Summary':'Add Summary'"
          (action)="add()"
        ></app-button>
      </div>
    </form>
  </div>
</div>
